import React from 'react';
import { ContactForm } from './ContactForm';
const QuoteFormSection = () => {
  return <section id="contact-form" className="py-16 bg-gray-100" data-id="element-273">
      <div className="container mx-auto px-4" data-id="element-274">
        <div className="text-center mb-12" data-id="element-275">
          <h2 className="text-3xl md:text-4xl font-bold mb-4" data-id="element-276">
            Get Your Free Quote Today
          </h2>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto" data-id="element-277">
            Fill out the form below and our team will provide you with a
            customized quote for your home or business technology needs.
          </p>
        </div>
        <div className="max-w-2xl mx-auto" data-id="element-278">
          <ContactForm data-id="element-279" />
        </div>
        <div className="mt-12 text-center" data-id="element-280">
          <p className="text-gray-600" data-id="element-281">
            Prefer to talk directly? Call us at{' '}
            <a href="tel:2392038333" className="text-blue-600 font-bold" data-id="element-282">
              (239) 203-8333
            </a>
          </p>
        </div>
      </div>
    </section>;
};
export default QuoteFormSection;